<template>
  <v-app>
    <app-sidenav v-if="showToolbars"/>

    <app-toolbar v-if="showToolbars"/>

    <v-main>
      <router-view @raison-event="openSnackBar"/>
    </v-main>

    <app-snackbar
      ref="appSnackbar"
      :type="snackbarType"
      :messages="snackbarMessages"
    />
  </v-app>
</template>

<script>
import AppToolbar from '@/components/layout/AppToolbar';
import AppSidenav from '@/components/layout/AppSidenav';
import AppSnackbar from '@/components/global/AppSnackbar';

export default {
  name: 'App',

  components: {
    AppToolbar,
    AppSidenav,
    AppSnackbar,
  },

  data() {
    return {
      snackbarMessages: [],
      snackbarType: 'error',
    };
  },

  computed: {
    showToolbars () {
      return !(this.$route.path === '/login');
    },
  },

  methods: {
    openSnackBar(raisonEvent) {
      let type = raisonEvent.type;
      let messages = raisonEvent.messages;
      this.snackbarType = type || 'error';
      messages = messages?.map(message => {
        let errorMessage = '';
        if (message && message.response && message.response.data && message.response.data.message) {
          errorMessage = message.response.data.message;
        }
        return errorMessage || message;
      });
      this.snackbarMessages = messages || [ 'Something went wrong...' ];
      this.$refs.appSnackbar.open = true;
    },
  },

  beforeCreate() {
    this.$i18n.locale = localStorage.getItem("raisonSelectedLanguage") ||  process.env.VUE_APP_I18N_LOCALE;
  },
};
</script>

<style>
@font-face {
  font-family: 'OpenSans';
  font-style: normal;
  font-weight: 400;
  src: local('OpenSans'), url('./fonts/OpenSans-Regular.ttf') format('truetype');
}

.v-application {
  font-family: "OpenSans", Roboto, sans-serif;
}

.v-content__wrap {
  background-color: #f3f1f2;
  font-family: "OpenSans", Roboto, sans-serif;
}
</style>
